'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_CreateGeneralPracticeRequest(practice, user) {
  this.Lapp_api_CreateGeneralPracticeRequest__f_practice = null;
  this.Lapp_api_CreateGeneralPracticeRequest__f_user = null;
  this.Lapp_api_CreateGeneralPracticeRequest__f_practice = practice;
  this.Lapp_api_CreateGeneralPracticeRequest__f_user = user;
}
export { $c_Lapp_api_CreateGeneralPracticeRequest as $c_Lapp_api_CreateGeneralPracticeRequest };
$c_Lapp_api_CreateGeneralPracticeRequest.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_CreateGeneralPracticeRequest.prototype.constructor = $c_Lapp_api_CreateGeneralPracticeRequest;
/** @constructor */
function $h_Lapp_api_CreateGeneralPracticeRequest() {
}
export { $h_Lapp_api_CreateGeneralPracticeRequest as $h_Lapp_api_CreateGeneralPracticeRequest };
$h_Lapp_api_CreateGeneralPracticeRequest.prototype = $c_Lapp_api_CreateGeneralPracticeRequest.prototype;
$c_Lapp_api_CreateGeneralPracticeRequest.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_api_CreateGeneralPracticeRequest.prototype.hashCode__I = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().productHash__s_Product__I__Z__I(this, 1236508463, true);
});
$c_Lapp_api_CreateGeneralPracticeRequest.prototype.equals__O__Z = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_api_CreateGeneralPracticeRequest)) {
    var x = this.Lapp_api_CreateGeneralPracticeRequest__f_practice;
    var x$2 = x$0.Lapp_api_CreateGeneralPracticeRequest__f_practice;
    if (((x === null) ? (x$2 === null) : x.equals__O__Z(x$2))) {
      var x$3 = this.Lapp_api_CreateGeneralPracticeRequest__f_user;
      var x$4 = x$0.Lapp_api_CreateGeneralPracticeRequest__f_user;
      return ((x$3 === null) ? (x$4 === null) : x$3.equals__O__Z(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$c_Lapp_api_CreateGeneralPracticeRequest.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_api_CreateGeneralPracticeRequest.prototype.productArity__I = (function() {
  return 2;
});
$c_Lapp_api_CreateGeneralPracticeRequest.prototype.productPrefix__T = (function() {
  return "CreateGeneralPracticeRequest";
});
$c_Lapp_api_CreateGeneralPracticeRequest.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_api_CreateGeneralPracticeRequest__f_practice;
  }
  if ((n === 1)) {
    return this.Lapp_api_CreateGeneralPracticeRequest__f_user;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_api_CreateGeneralPracticeRequest.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "practice";
  }
  if ((n === 1)) {
    return "user";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_api_CreateGeneralPracticeRequest(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_api_CreateGeneralPracticeRequest)));
}
export { $isArrayOf_Lapp_api_CreateGeneralPracticeRequest as $isArrayOf_Lapp_api_CreateGeneralPracticeRequest };
var $d_Lapp_api_CreateGeneralPracticeRequest = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_CreateGeneralPracticeRequest, "app.api.CreateGeneralPracticeRequest", ({
  Lapp_api_CreateGeneralPracticeRequest: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_api_CreateGeneralPracticeRequest as $d_Lapp_api_CreateGeneralPracticeRequest };
//# sourceMappingURL=app.api.-Create-General-Practice-Request.js.map
